// Module
var code = "<template> <require from=\"app/core/components/member/member-merge-history\"></require> <member-merge-history member-id.bind=\"memberId\"></member-merge-history> </template> ";
// Exports
module.exports = code;